import React, { Fragment, useEffect } from "react"
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const Monlix = ({})=> {

  const appId      = '3350';
  const currentUser = security.currentUserValue;

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        width="100%"
        frameBorder="0"
        style={{height: "92vh", margin: 0, padding: 0, border: 0}}
        src={`https://offers.monlix.com/?appid=${appId}&userid=${currentUser.id}`}
      ></iframe>

    </Fragment>
  );
};

export default Monlix;
